import { CardHeader, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import QueueIcon from '@material-ui/icons/Queue';
import { getUser } from 'src/utils/Common';
import React, { useEffect, useState } from 'react';
import axios from "src/utils/axios";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
  },
  button: {
    margin: theme.spacing(0.2),
  },
}));




function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, Header } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {Header.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {/* {order === 'desc' ? '' : ''} */}
                  {''}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}


function LeftPaneUp(props) {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [dataPaslasmaDone, setPaslasmaDataDone] = React.useState([]);
  const [dataPaslasmaWait, setPaslasmaDataWait] = React.useState([]);
  const [dataBelgeler, setdataBelgeler] = React.useState([]);
  const [pagination, setPagination] = useState({ page: 0, rowsPerPage: 10 });

  const [selectedRow, setselectedRow] = useState(-1);
  const [Loading, setLoading] = React.useState(false);
  const classes = useStyles();
  const user = getUser();

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect(() => {
    GetAllOpenPassDone();
    GetAllOpenPassWait();
  }, []);


  function GetAllOpenPassDone() {
    axios.get("GetAllOpenPass/" + user.ServiceShopId +"/1")
      .then(response => {
        console.log(response);
        setPaslasmaDataDone(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  function GetAllOpenPassWait() {
    axios.get("GetAllOpenPass/" + user.ServiceShopId +"/2")
      .then(response => {
        console.log(response);
        setPaslasmaDataWait(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  return (
    <div>
      <Paper>
        <CardHeader title="Son Paslaşmalar" />
        <Divider />
        <TableContainer style={{ height: 250, width: '100%' }}>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell padding='none' align="center">PaslaşmaNo</TableCell>
                          <TableCell padding='none' align="center">Durum</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stableSort(dataPaslasmaDone, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>                             
                              <TableCell padding='none' align="center" >
                                {row.PASLASMA_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.DURUM}
                              </TableCell>                             
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>.
      </Paper>
      <br />
      <Paper>
        <CardHeader title="Merkezde Bekleyen Belgeler" />
        <Divider />
        <TableContainer style={{ height: 250, width: '100%' }}>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell padding='none' align="center">PaslaşmaNo</TableCell>
                          <TableCell padding='none' align="center">Durum</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stableSort(dataPaslasmaWait, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>                             
                              <TableCell padding='none' align="center" >
                                {row.PASLASMA_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.DURUM}
                              </TableCell>                             
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>.
      </Paper >
    </div >
  );
}

export default LeftPaneUp;
